import React from 'react';
import { connect } from 'react-redux';

import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';

import PricingOptions from '../components/pricingoptions/PricingOptions';

import 'bootstrap/dist/css/bootstrap.css';
import '../../ext/font-awesome-4.7.0/css/font-awesome.css';
import './pricing.styl';

import { PageText as PageTextEN, Categories as CategoriesEN, PriceOptions as PriceOptionsEN } from '../input-text/en/pricing_page';
import { PageText as PageTextNL, Categories as CategoriesNL, PriceOptions as PriceOptionsNL } from '../input-text/nl/pricing_page';

class Pricing extends React.Component {
  constructor(props) {
    super(props);
    this.setLocale = this.setLocale.bind(this);
  }

  componentWillMount() {
      switch (this.props.lang) {
          case 'nl':
              this.props.setLocale(this.props.lang, true);
              break;
          default: this.props.setLocale(this.props.locale, true);
      }
  }

  componentWillUnmount() {
      this.props.setLocale(this.props.locale, false);
  }

  setLocale(locale) {
      this.PageText = null;
      this.Categories = null;
      this.PriceOptions = null;
      switch (this.props.locale) {
          case 'en':
              this.PageText = PageTextEN;
              this.Categories = CategoriesEN;
              this.PriceOptions = PriceOptionsEN;
              break;
          case 'nl':
              this.PageText = PageTextNL;
              this.Categories = CategoriesNL;
              this.PriceOptions = PriceOptionsNL;
              break;
          default:
              this.PageText = PageTextEN;
              this.Categories = CategoriesEN;
              this.PriceOptions = PriceOptionsEN;
      }
  }

  render(){
    this.setLocale(this.props.locale);

    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <i className="fa fa-shopping-cart fa-5x pricing-icon" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{this.PageText._1}</h1>
            <p>{this.PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer
          cols='1'
          category={ this.Categories._1 }
          component={ <PricingOptions options={ this.PriceOptions } /> }
        />
        <CategoryContainer
          cols='1'
          category={ this.Categories._2 }
        />
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale, hasTranslation) => dispatch({
      type: 'UPDATE_LOCALE',
      locale,
      hasTranslation,
    }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Pricing);



// WEBPACK FOOTER //
// ./src/routes/Pricing.js